import * as d3 from 'd3';
import { ChartDataArray } from '../data/ChartDataArray';
import { ChartDataType } from '../data/ChartDataType';
import { ColumnBarChartAttrHandler } from './ColumnBarChartAttrHandler';
import { ParallelColumnBarRenderer } from './ParallelColumnBarRenderer';

export class ParallelBarRenderer extends ParallelColumnBarRenderer {
  constructor(gElement: d3.Selection<SVGGElement, unknown, null, undefined>) {
    super(gElement);
  }

  public render(arrays: Array<ChartDataArray>, x: d3.ScaleLinear<number, number>, y: d3.ScaleBand<string>) {
    const breakdownData = arrays.filter(dataArray => dataArray.type === ChartDataType.breakdown);
    // build breakdownSeries, group by key
    const breakdownSeries = super.createBreakdownSeriesParallel(breakdownData).map(arr => {
      return arr.filter(d => {
        const dy = y(d.label!);
        return dy !== null && dy !== null;
      });
    });

    // scale for breakdown groups
    const yBreakdown: d3.ScaleBand<number> = d3
      .scaleBand<number>()
      .domain(d3.range(breakdownSeries.length))
      .range([5, y.bandwidth() - 5]);

    const zeroX = x(0);

    const handlers: ColumnBarChartAttrHandler = {
      x: d => Math.min(x(d.value), zeroX),
      y: d => y(d.label)!,
      width: d => Math.abs(zeroX - x(d.value)),
      height: () => yBreakdown.bandwidth(),
      transform: (_, i) => `translate( 0, ${yBreakdown(i)} )`,
    };

    super.renderInternal(breakdownSeries, handlers);
  }
}
